import React, { useContext } from "react";
import { Spin } from "antd";
import { ProtectedLayout } from "./ProtectedLayout";
import { Navigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const ProtectedRoute = ({ children }: Props) => {
  const { validateToken, isLoading } = useContext(AuthContext);

  // AuthProvider starts isLoading=true and runs an async loadSession() on
  // mount (which may include a silent refresh from a valid cookie even when
  // there's no access token in localStorage yet). Deciding on validateToken()
  // before that settles can redirect away a user who is about to be
  // authenticated, dropping any deep link they followed in.
  if (isLoading) {
    return <Spin style={{ display: "flex", justifyContent: "center", marginTop: "20%" }} />;
  }

  if (!validateToken()) {
    return <Navigate to="/" replace />;
  }

  return <ProtectedLayout>{children}</ProtectedLayout>;
};
